<a [class]="getClasses()"
   role="button"
   [attr.id]="id() + '-link'"
   [attr.aria-pressed]="selected"
   href=""
   (click)="onButtonClick($event)"
   [attr.aria-labelledby]="getAriaLabel()"
   [attr.aria-disabled]="disabled()"
   [name]="name()">

  @if (isIconLeftPositioned()) {
    <td-wb-icon size="20"
                [iconId]="getIcon()"
                class="td-wb-chip--icon" />
  }
  <div class="td-wb-chip__label"
       [attr.id]="'td-wb-aria-filter-name-' + id()">
    <ng-content />
  </div>
  @if (iconType() === 'remove') {
    <span [attr.id]="'td-wb-aria-remove-label-' + id()"
          class="td-wb-vh"
          translate="tdWb.chip.REMOVE"></span>
  }
  @if (iconType() === 'add') {
    <span [attr.id]="'td-wb-aria-select-label-' + id()"
          class="td-wb-vh"
          translate="tdWb.chip.SELECT"></span>
  }
  <span [attr.id]="'td-wb-aria-filters-' + id()"
        class="td-wb-vh"
        translate="tdWb.chip.FILTERS"></span>
  @if (isIconRightPositioned()) {
    <td-wb-icon size="20"
                [iconId]="getIcon()"
                class="td-wb-chip--icon" />
  }
</a>
